import EfCardHoverA from '@elem/ui/ef-card-hover-a';
import EfTitle from '@elem/ui/ef-title';
import { Fragment } from 'react';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

export default function TheComp() {
    const { t } = useLang('theProduct.SectionA');
    const { t: t2 } = useLang('theProduct');
    const itemsA = [
        {
            href: '#section-SectionB',
            gtm_position: t2('SectionB.title'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1723002419645/pc_list01.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1723002545824/m_list01.jpg',
            title: t('item1_title'),
            desc: t('item1_desc'),
        },
        {
            href: '#section-SectionC',
            gtm_position: t2('SectionC.title'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1723542426660/pc_list02.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1723542426485/m_list02.png',
            title: t('item2_title'),
            desc: t('item2_desc'),
        },
        {
            href: '#section-SectionI',
            gtm_position: t2('SectionI.title'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1723002419457/pc_list03.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1723002545914/m_list03.jpg',
            title: t('item3_title'),
            desc: t('item3_desc'),
        },
    ];

    return (
        <div className={styles.TheComp}>
            <EfTitle>{t('title')}</EfTitle>
            <div className="ef-container SectionA-in">
                {itemsA.map((item: any, index: number) => (
                    <Fragment key={index}>
                        <EfCardHoverA {...item} />
                    </Fragment>
                ))}
            </div>
        </div>
    );
}
